import { Button, ButtonProps } from './Button';

type Props = ButtonProps;
export function ButtonSecondary(props: Props) {
    return <Button {...props} variant="secondary" />;
}
